import React, { useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Controller, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

const testimonials = [
  {
    text: "Staying at Hoteler was an unforgettable experience. The staff went above and beyond to ensure our comfort and satisfaction. The room was immaculate, with breath-taking views.",
    name: "Jenny Wilson",
    designation: "Business Owner",
    thumb: "/images/resource/testi2-thumb1.png",
  },
  {
    text: "Staying at Hoteler was an unforgettable experience. The staff went above and beyond to ensure our comfort and satisfaction. The room was immaculate, with breath-taking views.",
    name: "Marvin McKinney",
    designation: "President of Sales",
    thumb: "/images/resource/testi2-thumb2.png",
  },
  {
    text: "Staying at Hoteler was an unforgettable experience. The staff went above and beyond to ensure our comfort and satisfaction. The room was immaculate, with breath-taking views.",
    name: "Jenny Wilson",
    designation: "Business Owner",
    thumb: "/images/resource/testi2-thumb3.png",
  },
];

export default function TestimonialSlider() {
  const [thumbsSwiper, setThumbsSwiper] = React.useState(null);

  return (
    <section className="testimonial-section-two pt-0">
      <div className="anim-icons">
        <img className="image-1" src="/images/icons/shape-5.png" alt="" />
      </div>
      <div className="auto-container">
        <div className="row">
          <div className="testimonials overflow-hidden col-lg-12">
            <Swiper
              modules={[Navigation, Thumbs]}
              navigation
              loop
              spaceBetween={30}
              thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
              className="testimonial-slider-content"
            >
              {testimonials.map((t, i) => (
                <SwiperSlide key={i}>
                  <div className="testimonial-block-two">
                    <div className="inner-box">
                      <div className="quote-icon">
                        <img className="icon-img" src="/images/icons/testi-shape1.png" alt="" />
                      </div>
                      <div className="text">{t.text}</div>
                      <div className="info-box">
                        <h5 className="name">{t.name}</h5>
                        <span className="designation">{t.designation}</span>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <Swiper
              modules={[Thumbs]}
              onSwiper={setThumbsSwiper}
              loop
              slideToClickedSlide
              slidesPerView="auto"
              centeredSlides
              spaceBetween={10}
              className="testimonial-thumbs mx-auto"
            >
              {testimonials.map((t, i) => (
                <SwiperSlide key={i}>
                  <img src={t.thumb} alt={t.name} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
}
